import { ProjectSaleItem } from "@/models/project-sale-item.model"
import { type IProjectSaleItem } from "@/interfaces/api/project-sale-item.interface"
import { ProjectSaleItemRepository } from "@/repositories/project-sale-item-repository"
import { useProjectsSaleItemsStore } from "@/store/projects-sale-items.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { AbstractProjectAdministrativeItemController } from "@/controllers/model-controllers/abstract/abstract-project-administrative-item-controller"

export class ProjectSaleItemController extends AbstractProjectAdministrativeItemController<
  ProjectSaleItem,
  IProjectSaleItem,
  ProjectSaleItemRepository
> {
  constructor() {
    const projectsSaleItemsStore = useProjectsSaleItemsStore()
    const { projectsSaleItems } = storeToRefs(projectsSaleItemsStore)
    const storeFunctionsConfig = {
      collection: projectsSaleItems
    }

    super(ProjectSaleItem, storeFunctionsConfig, new ProjectSaleItemRepository())
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      ProjectSaleItem,
      projectsSaleItems
    )
  }
}
